import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Filter } from "../interfaces/filter.interface";
import { ReceiptVoucherMST } from "../interfaces/resepit-voucher.interface";



@Injectable({
  providedIn: 'root',
})
export class ReceiptVoucherService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient, private router: Router) {}

  getVoucher(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl + '/ReceiptVoucher'}` + '/' + id);
  }

  listVouchers(
    PageNumber = 1,
    PageSize = 10,
    Term = '',
    filters?: Filter[]
  ): Observable<any> {
    const params = {
      term: Term,
      advancedFilter: filters,
      pageNumber: PageNumber,
      pageSize: PageSize,
    };
    return this.http.post(`${this.baseUrl + '/ReceiptVoucher/list'}`, params);
  }
  

  createVoucher(data: ReceiptVoucherMST): Observable<any> {
    return this.http.post(`${this.baseUrl + '/ReceiptVoucher'}`, data);
  }

  /**
   * Create voucher with FormData (supports file attachments)
   */
  createVoucherWithFormData(formData: FormData): Observable<any> {
    return this.http.post(`${this.baseUrl + '/ReceiptVoucher'}`, formData);
  }

  updateVoucher(id: number, data: ReceiptVoucherMST): Observable<any> {
    return this.http.put(`${this.baseUrl + '/ReceiptVoucher'}/${id}`, data);
  }

  /**
   * Update voucher with FormData (supports file attachments)
   */
  updateVoucherWithFormData(id: number, formData: FormData): Observable<any> {
    return this.http.put(`${this.baseUrl + '/ReceiptVoucher'}/${id}`, formData);
  }

  approveVoucher(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl + '/ReceiptVoucher'}/${id}/approve`, {});
  }

  deleteVoucher(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl + '/ReceiptVoucher'}` + '/' + id);
  }

  getJournals(voucherHeaderId: any): Observable<any> {
    return this.http.post(`${this.baseUrl + '/Journal/ByReference'}` , voucherHeaderId );
  }
  //
}
